export default {
  data() {
    return {
      obvOptions: {
        viewportTopPct: 0,
        viewportBottomPct: 100,
        pivotBegin: "top", // avail: top, bottom, center
        pivotEnd: "bottom", // avail: top, bottom, center
        offsetFromMenu: false,
      },
      obvProgress: {},
      obvItemOptions: {},
    };
  },
  computed: {
    offsetMultBegin() {
      switch (this.obvOptions.pivotBegin) {
        case "bottom":
          return 1;
        case "center":
          return 0.5;
        default:
          return 0;
      }
    },
    offsetMultEnd() {
      switch (this.obvOptions.pivotEnd) {
        case "bottom":
          return 1;
        case "center":
          return 0.5;
        default:
          return 0;
      }
    },
    offsetFromMenu() {
      return this.$vuetify.breakpoint.mdAndUp ? 70 : 46;
    },
    obv() {
      return (id) => {
        return this.obvProgress[id] || 0;
      };
    },
  },
  created() {
    window.addEventListener("scroll", this.obvOnScroll);
    window.addEventListener("resize", this.obvOnScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.obvOnScroll);
    window.removeEventListener("resize", this.obvOnScroll);
  },
  methods: {
    obvAddElement(id, options) {
      if (options) {
        this.$set(this.obvItemOptions, id, {
          ...this.obvOptions,
          ...options,
        });
      }
      this.$set(this.obvProgress, id, 0);
      this.obvOnScroll();
    },
    obvOnScroll() {
      const scrollY = window.scrollY;
      const local = this;
      const globalOpt = this.obvOptions;
      Object.keys(this.obvProgress).forEach((key) => {
        const element = document.getElementById(key);
        if (!element) return;
        const opt = this.obvItemOptions[key] || globalOpt;
        const offsetBegin = this.offsetMultBegin * element.clientHeight;
        const offsetEnd = this.offsetMultEnd * element.clientHeight;
        const viewportHeight =
          (window.innerHeight * (opt.viewportBottomPct - opt.viewportTopPct)) /
          100;
        const viewportBottom =
          (window.innerHeight * opt.viewportBottomPct) / 100 + scrollY;
        const pathLength = viewportHeight - offsetBegin + offsetEnd;
        const boundingRect = element.getBoundingClientRect();
        const elementTop = boundingRect.top + scrollY;
        if (pathLength == 0) {
          local.obvProgress[key] = 0;
          return;
        }
        const progress =
          (viewportBottom -
            elementTop +
            (opt.offsetFromMenu ? this.offsetFromMenu : 0) -
            offsetBegin) /
          pathLength;
        if (progress <= 0) {
          local.obvProgress[key] = 0;
        } else if (progress >= 1) {
          local.obvProgress[key] = 1;
        } else {
          local.obvProgress[key] = progress;
        }
      });
    },
  },
};
